// Фильтр слоя платформ: чистые операции над состоянием и коллекцией.
//
// ПУСТО = ВЕЗДЕ. Ни один тип не выбран — видно всё; то же правило, что у
// привязок видов к районам (`species_region`) и у реестра чатов бота. Читать
// пустоту как «ничего» значит гасить слой там, где вчера он работал, а пустой
// экран человек не отличит от сломанного.

export interface BuoyFeatureProps {
  platform_id: string
  platform_type: string | null
  freshness: string
  [key: string]: unknown
}

export type BuoyFeature = GeoJSON.Feature<GeoJSON.Point, BuoyFeatureProps>
export type BuoyCollection = GeoJSON.FeatureCollection<GeoJSON.Point, BuoyFeatureProps>

export interface BuoyFilter {
  /** Выбранные типы платформ; пусто — показываем все. */
  types: string[]
  /** Прятать ли устаревшие. По умолчанию НЕТ: молчащий буй — это факт о
   *  данных, а не мусор, и, спрятав его, мы ответили бы «буя нет» на вопрос
   *  «почему буй молчит». */
  hideStale: boolean
}

export const EMPTY_FILTER: BuoyFilter = { types: [], hideStale: false }

export function toggleType(filter: BuoyFilter, type: string): BuoyFilter {
  const has = filter.types.includes(type)
  return {
    ...filter,
    types: has ? filter.types.filter(t => t !== type) : [...filter.types, type],
  }
}

function passes(props: BuoyFeatureProps, filter: BuoyFilter): boolean {
  if (filter.types.length > 0 && !filter.types.includes(props.platform_type ?? '')) return false
  if (filter.hideStale && props.freshness !== 'fresh') return false
  return true
}

export function applyFilter(fc: BuoyCollection, filter: BuoyFilter): BuoyCollection {
  return { ...fc, features: fc.features.filter(f => passes(f.properties, filter)) }
}

export function visibleCount(fc: BuoyCollection, filter: BuoyFilter): number {
  return fc.features.reduce((n, f) => (passes(f.properties, filter) ? n + 1 : n), 0)
}
